import React, { useRef } from 'react';
import {
  FaLinkedin,
  FaSkype,
  FaGithub,
  FaWhatsapp,
  FaTwitter,
  FaPaperPlane,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from 'react-icons/fa';
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_portfolioEmail',
        'template_dorho53',
        form.current,
        'gI1Kuk7YE6lOX34yB'
      )
      .then(
        (result) => {
          Swal.fire({
            icon: 'success',
            title: 'Email sent successfully',
            showConfirmButton: false,
            timer: 5000,
          });
        },
        (error) => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: error?.text,
            showConfirmButton: false,
            timer: 5000,
          });
        }
      );
    e.target.reset();
  };

  return (
    <section id="contact" className="contact-bg-img py-14 md:py-24">
      <div className="overlay bg-gradient-to-b  from-light-blue dark:from-light-black"></div>

      <div className="relative max-w-screen-xl mx-auto px-2 bg-light-blue rounded dark:bg-light-black dark:opacity-80">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 p-4 md:p-10">
          <div
            className="order-2 md:order-1"
            data-aos="zoom-in-right"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          >
            <h3
              className="text-4xl font-black dark:text-white underline underline-offset-[8px] decoration-orange mb-8"
              style={{ fontFamily: " 'Dancing Script', cursive" }}
            >
              Send A Message
            </h3>
            <form ref={form} onSubmit={sendEmail}>
              <input
                className="rounded px-2 py-2 mb-4 w-full bg-white border focus:outline-none focus:border-orange"
                type="text"
                name="client_name"
                placeholder="Name"
                required
              />
              <input
                className="rounded px-2 py-2 mb-4 w-full bg-white border focus:outline-none focus:border-orange"
                type="text"
                name="client_email"
                pattern='^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$'
                placeholder="Email"
                required
              />
              <input
                className="rounded px-2 py-2 mb-4 w-full bg-white border focus:outline-none focus:border-orange"
                type="text"
                name="client_m_subject"
                placeholder="Subject"
                required
              />
              <textarea
                className="rounded px-2 py-2 mb-4 w-full bg-white border focus:outline-none focus:border-orange"
                cols="30"
                rows="8"
                name="client_message"
                placeholder="Message"
                required
              />
              <button></button>
              <button
                type="submit"
                className="rounded py-3 px-6 bg-orange text-white"
              >
                <span className="flex items-center font-semibold">
                  Send Message <FaPaperPlane className="ml-2" />
                </span>
              </button>
            </form>
          </div>

          <div
            className="dark:text-white order-1 md:order-2"
            data-aos="fade-up"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          >
            <h3
              className="text-4xl font-black underline underline-offset-[8px] decoration-orange mb-6"
              style={{ fontFamily: " 'Dancing Script', cursive" }}
            >
              Get in Touch
            </h3>
            <p className="text-[18px]">
              Whether you want to get in touch, talk about a project
              collaboration, or just say hi, I'd love to hear from you. Simply
              fill the from and send me an email.
            </p>

            <div className="mt-10">
              <div className="flex my-5 items-center">
                <FaPhoneAlt className="text-3xl text-orange mr-2" />
                <div className="block">
                  <h5 className="font-semibold text-xl">Call Me</h5>
                  <span>
                    <a
                      href="tel:+880-1797570726"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      +880-1797-570726
                    </a>
                  </span>
                </div>
              </div>
              <div className="flex my-5 items-center">
                <FaEnvelope className="text-3xl text-orange mr-2" />
                <div className="block">
                  <h5 className="font-semibold text-xl">Email</h5>
                  <span>
                    <a
                      href="mailto:liazulislam11@gmail.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      liazulislam11@gmail.com
                    </a>
                  </span>
                </div>
              </div>
              <div className="flex my-5 items-center">
                <FaMapMarkerAlt className="text-3xl text-orange mr-2" />
                <div className="block">
                  <h5 className="font-semibold text-xl">Location</h5>
                  <a
                    href="https://www.google.com/maps/dir//Bangladesh/@23.4956374,88.1011574,7z/data=!4m9!4m8!1m0!1m5!1m1!1s0x30adaaed80e18ba7:0xf2d28e0c4e1fc6b!2m2!1d90.356331!2d23.684994!3e0"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Tangail, Dhaka, Bangladesh
                  </a>
                </div>
              </div>
            </div>

            <div className="social-links flex text-3xl mt-10 md:mt-[100px] pb-5 md:pb-0">
              <a
                className="hover:text-orange transform translate duration-500 mr-5 dark:text-white dark:hover:text-orange"
                href="https://www.linkedin.com/in/liazul"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin />
              </a>
              <a
                className="hover:text-orange transform translate duration-500 mr-5 dark:text-white dark:hover:text-orange"
                href="https://join.skype.com/invite/o9hkLAsJNG1D"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaSkype />
              </a>
              <a
                className="hover:text-orange transform translate duration-500 mr-5 dark:text-white dark:hover:text-orange"
                href="https://github.com/mohammadliazul"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaGithub />
              </a>
              <a
                className="hover:text-orange transform translate duration-500 mr-5 dark:text-white dark:hover:text-orange"
                href="https://wa.me/+8801797570726"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaWhatsapp />
              </a>
              <a
                className="hover:text-orange transform translate duration-500 dark:text-white dark:hover:text-orange"
                href="https://twitter.com/liazul_islam"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTwitter />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center">
        <p className="text-white z-50 bg-transparent absolute text-center bottom-4">
          &copy; {new Date().getFullYear()}{' '}
          <a
            className="hover:text-blue-500 hover:underline transition-all duration-500"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.linkedin.com/in/liazul/"
          >
            Liazul
          </a>
          . All Rights Reserved.
        </p>
      </div>
    </section>
  );
};

export default Contact;
